"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
const api_1 = require("@/api");
function getProfile({ retryCount, onSuccess, onError, }) {
    return __awaiter(this, void 0, void 0, function* () {
        if (retryCount > 0) {
            const retryFunc = () => setTimeout(() => getProfile({ retryCount: retryCount - 1, onSuccess, onError }), 1000);
            yield (0, api_1.getData)('/api/v1/profile/auth/')
                .then(res => {
                if (res.status === 200) {
                    onSuccess();
                }
                else {
                    retryFunc();
                }
            })
                .catch(retryFunc);
        }
        else {
            onError();
        }
    });
}
exports.default = getProfile;
